<template>
	<div>
		<header>
			<div></div>
			<nav v-if="isloggedIn && $route.name != 'Login'">
				<ul>
					<li class="myprofile">
						<a @click="setModalProfileEditVisibility(true)">
							<span></span>
							Min profil
						</a>
					</li>
					<li class="menutoggle">
					</li>
				</ul>
			</nav>
		</header>
	</div>
</template>

<script>
	import { types } from "@/app/types/types";

	export default {
		methods: {
			logout()
			{
				this.$store.dispatch(types.ACTION_LOGOUT_USER)
			}
		}
	}
</script>